var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAngleLeft = function SvgAngleLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.592 3 4.57 7.623a.517.517 0 0 0 0 .754L9.592 13",
    stroke: "#14161A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAngleLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuNTkxNTUgM0w0LjU3MDA0IDcuNjIzMDhDNC41MTg1MyA3LjY3MTQyIDQuNDc3NDcgNy43Mjk4MSA0LjQ0OTQxIDcuNzk0NjRDNC40MjEzNCA3Ljg1OTQ3IDQuNDA2ODYgNy45MjkzNiA0LjQwNjg2IDhDNC40MDY4NiA4LjA3MDY0IDQuNDIxMzQgOC4xNDA1NCA0LjQ0OTQxIDguMjA1MzZDNC40Nzc0NyA4LjI3MDE5IDQuNTE4NTMgOC4zMjg1OCA0LjU3MDA0IDguMzc2OTJMOS41OTE1NSAxMyIgc3Ryb2tlPSIjMTQxNjFBIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";